import { useEffect } from 'react';

import { useAppSelector } from '../store/hooks';
import { selectPreparedData } from '../features/table/table.selectors';

export function Counter() {
  const preparedData = useAppSelector(selectPreparedData);
  const websitesData = useAppSelector((state) => state.table.websitesData);
  const env = websitesData?.env;
  const websites = websitesData?.websites ?? [];

  useEffect(() => {
    let title = '';
    if (preparedData) {
      title += `[${preparedData.length}]`;
    }
    if (env) {
      title += `[${env}]`;
    }
    title += `: ${__PAGE_TITLE__}`;
    document.title = title;
  }, [env, preparedData]);

  return (
    <div className="counter" data-qa="counter">
      {preparedData.length < websites.length && `${preparedData.length}/`}
      {websites.length}
    </div>
  );
}
